import { render, staticRenderFns } from "./PacientiLayout.vue?vue&type=template&id=0bd640ed&"
import script from "./PacientiLayout.vue?vue&type=script&lang=js&"
export * from "./PacientiLayout.vue?vue&type=script&lang=js&"
import style0 from "./PacientiLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports